import { Box, Button, Chip, IconButton, LinearProgress, Link, TextField, Tooltip, Typography } from "@mui/material";
import { parseISO } from "date-fns";
import { formatTimeAgo } from "./DateText";
import { Link as RouterLink } from "react-router-dom";
import { UserAvatar } from "./UserAvatar";
import ReplyIcon from '@mui/icons-material/Reply';
import ShowRepliesIcon from '@mui/icons-material/AddCircle';
import HideRepliesIcon from '@mui/icons-material/RemoveCircleOutline';
import { MyListApi } from "../utils/restApi";
import { useState } from "react";
import ReplyArrowIcon from '@mui/icons-material/SubdirectoryArrowRight';
import { NewComment } from "./NewComment";
import { useDispatch, useSelector } from "react-redux";
import { addNotification } from "../slices/notificationSlice";

export const Comment = ({ comment }) => {

    const dispatch = useDispatch();

    const user = useSelector(state => state.login.user);

    const [repliesOpen, setRepliesOpen] = useState(false);
    const [addReplyOpen, setAddReplyOpen] = useState(false);
    // const [newComment, setNewComment] = useState('');
    const [replies, setReplies] = useState(null);

    // const avatarName = comment.createdBy.name.slice(0, 2).toUpperCase();

    // const addReply = () => {

    // }

    // const getReplies = () => {
    //     MyListApi.getComments('COMMENT', comment.id, 0)
    //         .then(data => {

    //         })
    //         .catch(error => {

    //         });
    // }

    const handleAddReply = () => {
        setAddReplyOpen(!addReplyOpen);
    }

    const handleShowReplies = () => {
        setRepliesOpen(!repliesOpen);
        MyListApi.getComments('COMMENT', comment.id, 0)
            .then(data => {
                setReplies(data.items);
            })
            .catch(error => {
                dispatch(addNotification({
                    message: error.message,
                    type: 'error',
                }));
            });
    }

    const hasReplies = comment?.replyCount > 0;

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
            <Box sx={{ display: 'flex', flexDirection: 'row', gap: '12px', borderTop: 1, borderColor: 'divider', pt: '15px', minWidth: 0 }}>
                <UserAvatar user={comment.createdBy} size='medium' />
                <Box sx={{ width: '100%', minWidth: 0 }}>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'baseline', gap: '6px' }}>
                        <Link component={RouterLink} to={`/user/${comment.createdBy.id}/items`} color="text.primary" sx={{ fontWeight: 600, fontSize: '0.875rem' }}>{comment.createdBy.name}</Link>
                        <Typography variant="caption" color="text.secondary">· {formatTimeAgo(parseISO(comment.createdAt))}</Typography>
                    </Box>
                    <Typography sx={{ fontSize: '0.875rem', mt: '4px', overflowWrap: 'anywhere', whiteSpace: 'pre-line' }}>{comment.text}</Typography>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end'}}>
                        <Box sx={{ display: 'flex', flexDirection: 'row', gap: '10px', alignItems: 'center' }}>
                            {hasReplies ? <Tooltip title="Replies" placement="top"><Chip onClick={handleShowReplies} size="small" variant="outlined" aria-label={`${repliesOpen ? 'Hide' : 'Show'} ${comment?.replyCount} replies`} aria-expanded={repliesOpen} icon={repliesOpen ? <HideRepliesIcon /> : <ShowRepliesIcon />} label={`${comment?.replyCount}`} /></Tooltip> : null}
                            {user ? <Tooltip title="Reply" placement="top" enterDelay={500}><IconButton size="small" aria-label="Reply" aria-expanded={addReplyOpen} onClick={handleAddReply} sx={{ '& svg': { fontSize: '16px' }}}><ReplyIcon /></IconButton></Tooltip> : null}
                        </Box>
                    </Box>
                </Box>
            </Box>
            <Box sx={{ display:  ((repliesOpen || addReplyOpen) ? "flex" : "none" ), flexDirection: 'row' }}>
                <Box><ReplyArrowIcon aria-hidden="true" sx={{ color: 'sage.main' }} /></Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', borderRadius: '8px', gap: '10px' }}>
                    {addReplyOpen ?
                        <Box>
                            <NewComment entityType='COMMENT' entityId={comment.id} />
                        </Box>
                    : null}
                    {(repliesOpen && replies !== null) ? replies.map(r => <Comment key={r.id} comment={r} />) : null}
                </Box>
            </Box>
        </Box>
    );
}